var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"st-Modal_Container"},[(_vm.closeBtn)?_c('div',{staticClass:"st-Modal_CloseBtn",on:{"click":_vm.closeModal}}):_vm._e(),_vm._v(" "),_c('div',{class:[_vm.scrollContent && 'sw-Scrollbar', 'st-Modal_Contents']},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }